import React from "react";
import "./ServicesDisplay.scss";
import { useSelector } from "react-redux";

import { AiOutlineCheck, AiOutlineInfoCircle } from "react-icons/ai";
import { BsChevronRight } from "react-icons/bs";
import { MdKeyboardArrowDown } from "react-icons/md";

// import servicesData from "../../data/servicesData.json";

const ServicesDisplay = (props) => {
  const steps = useSelector((state) => state.widget.steps);
  const companyServices = useSelector((state) => state.widget.widget.services);
  const place = useSelector((state) => state.widget.place);

  const handleClick = (e) => {
    e.target.classList.toggle("expand");
  };

  const mapServices = (category, catIndex) => {
    return (
      category &&
      category.map((object, index) => (
        <div
          key={index}
          className={
            "Service" +
            (props.choose ? " choose" : "") +
            (props.choose
              ? catIndex === props.choosen.category &&
                index === props.choosen.service
                ? " booked"
                : ""
              : "")
          }
          onClick={() =>
            props.onChoose(
              object.name,
              object.duration,
              object.price,
              object.id
            )
          }
        >
          <div className="description">
            <p>{object.name}</p>
            <span>
              {object.duration} min,{object.price} kr
            </span>
            {object.notes && (
              <span className="notes">
                <AiOutlineInfoCircle /> {object.notes}
              </span>
            )}
          </div>
          {/* {props.boka && (
            <Link to={`/book/${props.place.id}?service_id=${object.id}&service_name=${object.name}&duration=${object.duration}&price=${object.price}`} className="boka">
              Boka
            </Link>
          )} */}
          {props.choose && (
            <button className="choose">
              <AiOutlineCheck />
            </button>
          )}
          <BsChevronRight className="chevron" />
        </div>
      ))
    );
  };

  const services =
    steps === 4
      ? companyServices.map((category, index) => {
          return (
            <div className="Category" key={index}>
              <div className="title expand" onClick={handleClick}>
                <h5>{category && category.name}</h5>
                <MdKeyboardArrowDown />
              </div>

              {mapServices(category.services, index)}
            </div>
          );
        })
      : place &&
        place.services.map((category, index) => {
          return (
            <div className="Category" key={index}>
              <div className="title expand" onClick={handleClick}>
                <h5>{category && category.name}</h5>
                <MdKeyboardArrowDown />
              </div>

              {mapServices(category.services, index)}
            </div>
          );
        });

  return <div className="ServicesDisplay">{services}</div>;
};

export default ServicesDisplay;
